/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (platform)
  {
    this.platform = platform;
  }


  isExternalBorder (neighbor)
  {
    const neighborPlatform = neighbor.getPlatform();

    return !neighborPlatform || this.platform.getUserID() !== neighborPlatform.getUserID();
  }


  isGroupBorder (neighbor)
  {
    return false;
  }


}
